import { styled } from 'styled-components';
import { sizes } from 'theme';

export const LogoImage = styled.img`
    border-radius: ${sizes.borderRadiusMd};
    max-width: 244px;
    max-height: 88px;
    width: auto;
    height: auto;
    object-fit: contain;
`;
